module.exports = __webpack_public_path__ + "img/微信小程序二维码.359d0868.png";